var _defs, _path, _g, _path2, _g2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointsCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 221.598,
    height: 221.6,
    viewBox: "0 0 221.598 221.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_694",
    "data-name": "Rectangle 694",
    width: 192.051,
    height: 192.052,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_695",
    "data-name": "Rectangle 695",
    width: 161.98,
    height: 161.979,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1356",
    "data-name": "Group 1356",
    transform: "translate(-1072.076 -710.271)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8720",
    "data-name": "Path 8720",
    d: "M1279.205,765.484a110.8,110.8,0,1,1-110.8-110.8,110.795,110.795,0,0,1,110.8,110.8",
    transform: "translate(14.469 55.589)",
    fill: "#ffca00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1296",
    "data-name": "Group 1296",
    transform: "translate(1101.623 710.271)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1295",
    "data-name": "Group 1295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1294",
    "data-name": "Group 1294",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8721",
    "data-name": "Path 8721",
    d: "M1187.833,654.681a110.487,110.487,0,0,0-81.25,35.492,110.78,110.78,0,0,1,156.551,156.56,110.782,110.782,0,0,0-75.3-192.052",
    transform: "translate(-1106.581 -654.681)",
    fill: "#ffca00"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8722",
    "data-name": "Path 8722",
    d: "M1273.125,777.16a93.036,93.036,0,1,1-93.038-93.041,93.038,93.038,0,0,1,93.038,93.041",
    transform: "translate(2.79 43.913)",
    fill: "#fba500"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1299",
    "data-name": "Group 1299",
    transform: "translate(1089.841 752.131)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1298",
    "data-name": "Group 1298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1297",
    "data-name": "Group 1297",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8723",
    "data-name": "Path 8723",
    d: "M1186.555,879.565a93.035,93.035,0,0,1-68.936-155.5A93.034,93.034,0,1,0,1249.03,855.468a92.7,92.7,0,0,1-62.475,24.1",
    transform: "translate(-1087.051 -724.059)",
    fill: "#fba500"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8724",
    "data-name": "Path 8724",
    d: "M1243.526,861.5a33.733,33.733,0,0,1-47.7,0l-9.179-9.172,1.839-1.839a12.973,12.973,0,0,1,18.344,0,18.164,18.164,0,0,0,25.691-25.683l-23.853-23.853a15.574,15.574,0,0,1,0-22.021l34.856,34.863a33.729,33.729,0,0,1,0,47.705",
    transform: "translate(-36.714 6.309)",
    fill: "#ffe600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8725",
    "data-name": "Path 8725",
    d: "M1239.414,749.282l9.174,9.174-1.835,1.835a12.973,12.973,0,0,1-18.347,0,18.163,18.163,0,0,0-25.686,25.686l23.851,23.851a15.568,15.568,0,0,1,0,22.017l-34.859-34.859a33.731,33.731,0,0,1,47.7-47.7",
    transform: "translate(-34.803 21.986)",
    fill: "#ffe600"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointsCoin);
export default __webpack_public_path__ + "static/media/points-coin.fb1fba166991ad5e09e45f747de6c2af.svg";
export { ForwardRef as ReactComponent };